import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import Links from '../../common/Links';
import Button from '../../common/Button';
import InputBox from '../../common/InputBox';
import Lopa from '../../assets/LopaaLogo.png';
import { signUpUser } from '../../api/Auth';
import ToastNotification from '../../common/ToastNotification';
import { validateForm } from '../../function/FormValidation';
import EyeButton from '../../common/EyeButton';
import SelectBusinessType from './SelectBusinessType';

interface IForm {
  email: string;
  password: string;
  businessType: string;
}

const formInit: IForm = {
  email: '',
  password: '',
  businessType: ''
};

const SignUp = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const key = searchParams.get('key');
  // const key: string = "ODOO";
  const shopUuid = searchParams.get('shopUuid');
  const businessType: any = searchParams.get('businessType');
  const shopurl = searchParams.get('shopurl');
  const decodedShopUrl = shopurl ? decodeURIComponent(shopurl) : "";
  const emailParam = searchParams.get('email');
  const decodedEmail = emailParam ? decodeURIComponent(emailParam) : "";
  // const shopUuid = "nishi.wordpress.com";
  const [form, setForm] = useState({ email: '', password: '', businessType: '' });

  const [errors, setErrors] = useState<{
    email?: string;
    password?: string;
    businessType?: string;
  }>({});
  const [disable, setDisable] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const inputHandler = (value: string, type: string) => {
    setForm({ ...form, [type]: value });
    setErrors({ ...errors, [type]: '' });
  };

  const submithandler = async () => {
    const fieldsToValidate = ['email', 'password'];
    if (!(key === 'SHOPIFY' || key === 'WORDPRESS' || key === 'ODOO')) {
      fieldsToValidate.push('businessType');
    }


    const { isValid, errors } = validateForm(form, fieldsToValidate);
    setErrors(errors);

    const payload = {
      email: form.email,
      password: form.password,
      businessType:
        key === 'SHOPIFY'
          ? 'Retail'
          : key === 'WORDPRESS'
            ? businessType ? businessType : "WordpressRetail" : key === 'ODOO' ? businessType ? businessType : "OdooRetail"
              : form.businessType === 'Real Estate'
                ? 'Estate'
                : form.businessType
    };

    if (isValid) {
      try {
        setDisable(true);
        sessionStorage.setItem('shopurl', decodedShopUrl);
        sessionStorage.setItem('adminEmail', decodedEmail);
        sessionStorage.setItem("businessType", businessType);
        const response = await signUpUser(payload, key ? key : null, shopUuid ? shopUuid : null);
        if (response.ok) {
          const data = await response.json();
          ToastNotification({
            message: data.message
          });
          const userId = data?.payload?.userUUID;

          setTimeout(() => {
            navigate(`/otp/${userId}`, { state: { email: form.email } });
            setDisable(false);
            setForm(formInit);
          }, 1500);
        } else {
          const errorData = await response.json();
          if (errorData.payload) {
            const firstError = Object.values(errorData.payload).flat()[0];
            if (typeof firstError === 'string') {
              ToastNotification({
                message: firstError,
                type: 'error'
              });
            }
          } else {
            ToastNotification({
              message: errorData.message,
              type: 'warning'
            });
          }

          setDisable(false);
        }
      } catch (error) {
        ToastNotification({
          message: 'Something went wrong. Please try again later.',
          type: 'error'
        });
        setDisable(false);
      }
    }
  };

  useEffect(() => {
    if ((businessType === "WordpressRetail" || businessType === "OdooRetail") && decodedEmail) {
      // Autofill the email field
      inputHandler(decodedEmail, 'email');
    }
  }, [businessType, decodedEmail]);


  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <>
      <div className="flex justify-center py-2">
        <img src={Lopa} className="lg:w-32 lg:h-[60px] w-[101px] h-12" alt="Matrix AI" />
      </div>
      <div className="flex  h-full flex-col justify-center items-center px-2 py-1  lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-lg p-2">
          <h2 className=" text-start text-[25px]   md:text-[36px] md:leading-[50.33px] font-bold tracking-tight">
            Welcome!
          </h2>
          {/* <span className="font-normal sm:text-[20px] sm:leading-[37.66px] md:text-[28px]  md:leading-[39.28px]">
            Support system of Sulopa&apos;s
          </span> */}
          <div className="mt-2 sm:mx-auto sm:w-full sm:max-w-lg">
            <div className="space-y-3">
              {/* <div>
                  <InputBox
                    name="businessName"
                    type="text"
                    value={formData.businessName}
                    placeholder="Business Name"
                    handleChange={handleChange}
                    error={errors.businessName}
                  />
                </div> */}
            </div>
            <div>
              <div className="mt-0">
                <InputBox
                  name="email"
                  type="email"
                  value={form.email}
                  placeholder="Email"
                  handleChange={(evenet) => inputHandler(evenet.target.value, 'email')}
                  error={errors.email}
                  disabled={businessType === "WordpressRetail" || businessType === "OdooRetail"}
                  style={
                    businessType === "WordpressRetail" || businessType === "OdooRetail"
                      ? { cursor: "not-allowed", backgroundColor: "#505050" }
                      : {}
                  }

                />
              </div>
            </div>
            <div className={`${errors.password?.length == 118 ? 'mb-8' : ''}`}>
              <div className="mt-0 relative">
                <InputBox
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  value={form.password}
                  placeholder="Password"
                  handleChange={(evenet) => inputHandler(evenet.target.value, 'password')}
                  error={errors.password}
                />
                <EyeButton
                  showPassword={showPassword}
                  togglePasswordVisibility={togglePasswordVisibility}
                />
              </div>
            </div>
            {!(!!key && key === 'SHOPIFY' || key === 'WORDPRESS' || key === "ODOO") && (
              <SelectBusinessType
                selectedValue={form.businessType}
                onSelectChange={(value: string) => inputHandler(value, 'businessType')}
                errors={errors.businessType}
              />
              // <div>
              //   <div className="mt-0 relative">
              //     <AppDropdown
              //       placeHolder="Select Buisness Type"
              //       option={BUISNESS_LIST}
              //       selectedValue={form.businessType}
              //       onChange={(value: string) => inputHandler(value, 'businessType')}
              //     />
              // {errors.businessType && (
              //   <span className="error ps-1 text-[#ff4c4c]">{errors.businessType}</span>
              // )}
              //   </div>
              // </div>
            )}
            <div>
              {/* <div className="mt-3 relative">
                  <InputBox
                    name="confirmPassword"
                    type={showConfirmPassword ? 'text' : 'password'}
                    value={formData.confirmPassword}
                    placeholder="Confirm Password"
                    handleChange={handleChange}
                    error={errors.confirmPassword}
                  />
                  <EyeButton
                    showPassword={showConfirmPassword}
                    togglePasswordVisibility={toggleConfirmPasswordVisibility}
                  />
                </div> */}
            </div>
            <div className="mt-3">
              <Button
                isFormValid={true}
                disable={disable}
                btnText="Sign up"
                textColor="#FFFFFF"
                backGroundColor="#006BEA"
                borderColor=""
                onClick={submithandler}
              />
            </div>
            {/* <div className="mt-8">
              <Icon />
            </div> */}
            <div className="flex justify-center items-center gap-2 text-base">
              <label>Already have an account ?</label>
              <Link to="/login" className="underline text-[#006BEA] font-semibold">
                Login
              </Link>
            </div>
            <div className="mt-6">
              <Links />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignUp;
